var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserFilter',{attrs:{"isSubFilter":true,"isOnline":false},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }